<template>
    <FullFillBox
        :pageID="1010"
        @permissionData="(data) => {
            this.permissionDetails = data
            if((data.add === 1 && this.flag === 'add') || (data.edit === 1 && this.flag === 'update')){
                // pass
            }else{
                this.$toast.error(this.$t('error_no_permission'))
                this.$router.push('/product')
            }
        }"
    >
        <ProductDetailsBox
            v-if="doneLoading"
            :getOutCode="outCode"
            :getFlag="flag"
            style="padding: 5px"
        />
    </FullFillBox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import ProductDetailsBox from "@/components/ProductDetailsBox";

export default {
    name: "ProductProcessView",
    components: {
        FullFillBox,
        ProductDetailsBox,
    },
    data(){
        return{
            permissionDetails: {},
            doneLoading: false,
            flag: '',
            outCode: '',
        }
    },
    mounted() {
        // If code is "add", then is Add new Item
        // Else, it must be a product outCode, update mode
        document.title = this.$t('title') + ' | ' + this.$t('product_manage')

        this.outCode = this.$route.params.code
        if(this.outCode === "add"){
            this.flag = "add"
        }else{
            this.flag = "update"
        }
        this.doneLoading = true
    },
    methods: {

    }
}
</script>

<style scoped>

</style>
